/**
 * Base URL for the backend API.
 * - Dev:  http://localhost:8787 (the wrangler dev server)
 * - Prod: https://api.minertia.co.za
 * Set via VITE_API_URL in the environment / Cloudflare Pages settings.
 */
export const API_URL = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');

/**
 * Base URL of the frontend app itself, used as the redirect target for
 * password-recovery emails. Defaults to the current origin (works in both dev
 * and prod); override with VITE_APP_URL if needed.
 */
export const APP_URL = (
  import.meta.env.VITE_APP_URL ?? window.location.origin
).replace(/\/$/, '');

/**
 * Display name for the app, used as the TOTP issuer shown in authenticator
 * apps (e.g. "Minertia: user@example.com"). Override with VITE_APP_NAME.
 */
export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'Minertia';
